(function () {
    'use strict';

    angular.module("imApp").factory("orderLineCreditCauseLangService", ['$ihttp', function ($ihttp) {
        let service = {
            listOrderLineCreditCauseLanguages: function (parms) {
                return $ihttp.post({
                    method: 2764,
                    parameters: parms || {}
                });
            },
            saveObj: function (list) {
                return $ihttp.post({
                    method: 2765,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
